
export const navigationConfig = [
  {
    category: "dashboard",
    label: "Dashboard",
    items: [
      {
        path: "/Dashboard",
        displayNameKey: "dashboard",
        iconClass: "bi bi-speedometer2",
        roles: ["admin"],
        menuProperty: "DashboardMenuNo"
      }
    ]
  },
  {
    category: "data-management", 
    label: "Data Management",
    items: [
      {
        path: "/Industry/List",
        displayNameKey: "industry",
        iconClass: "bi bi-building",
        roles: ["admin"],
        menuProperty: "IndustryMenuNo"
      },
      {
        path: "/Company/List",
        displayNameKey: "company",
        iconClass: "bi bi-briefcase",
        roles: ["admin"],
        menuProperty: "CompanyMenuNo"
      },
      {
        path: "/MergeAndAcquisition/List",
        displayNameKey: "mergeAndAcquisition",
        iconClass: "bi bi-diagram-3",
        roles: ["admin"],
        menuProperty: "MergerAndAcquisitionMenuNo"
      }
    ]
  },
  {
    category: "visualization",
    label: "Data Visualization", 
    items: [
      {
        path: "/Graphs/MAndATimelineGraph",
        displayNameKey: "MAndATimelineGraphTimeLine",
        iconClass: "bi bi-graph-up",
        roles: ["admin"],
        menuProperty: "MAndATimelineGraphMenuNo"
      },
      {
        path: "/Graphs/NetworkGraph",
        displayNameKey: "MAndATimelineGraphNetworkGraph",
        iconClass: "bi bi-diagram-2",
        roles: ["admin"],
        menuProperty: "NetworkGraphMenuNo"
      },
      {
        path: "/Graphs/SankeyDiagram",
        displayNameKey: "MAndATimelineGraphNSankeyDiagram",
        iconClass: "bi bi-flow-chart",
        roles: ["admin"],
        menuProperty: "SankeyDiagramMenuNo"
      }
    ]
  },
  {
    category: "ai-agents",
    label: "AI Agents",
    items: [
      {
        path: "/MADiscovery/Dashboard",
        displayNameKey: "🤖 AI M&A Discovery Agent",
        iconClass: "bi bi-robot",
        roles: ["admin"],
        menuProperty: "MADiscoveryMenuNo"
      }
    ]
  },
  {
    category: "analysis",
    label: "Data Analysis",
    items: [
      {
        path: "/DataDistribution/DataDistributionDashboard",
        displayNameKey: "DataDistribution",
        iconClass: "bi bi-bar-chart-line",
        roles: ["admin"],
        menuProperty: "DataDistributionMenuNo"
      },
      {
        path: "/Methodology/MethodologyDiagram",
        displayNameKey: "Methodology",
        iconClass: "bi bi-diagram-2-fill",
        roles: ["admin"],
        menuProperty: "MethodologyMenuNo"
      },
      {
        path: "/AblationStudy/Benchmark",
        displayNameKey: "Algorithm Benchmark",
        iconClass: "bi bi-speedometer2",
        roles: ["admin"],
        menuProperty: "AblationBenchmarkMenuNo"
      },
      {
        path: "/MAForecast/MAForecastGraph",
        displayNameKey: "M&A Forecast",
        iconClass: "bi bi-graph-up-arrow",
        roles: ["admin"],
        menuProperty: "MAForecastGraphMenuNo"
      },
      {
        path: "/nvidia-analysis",
        displayNameKey: "NVIDIA AI Analysis",
        iconClass: "bi bi-cpu",
        roles: ["admin"],
        menuProperty: "NvidiaAnalysisMenuNo"
      },
      {
        path: "/qualcomm-analysis",
        displayNameKey: "Qualcomm/Arduino Analysis",
        iconClass: "bi bi-robot",
        roles: ["admin"],
        menuProperty: "QualcommAnalysisMenuNo"
      },
      {
        path: "/WaveForecasting/Dashboard",
        displayNameKey: "Wave Forecasting",
        iconClass: "bi bi-graph-up-arrow",
        roles: ["admin"],
        menuProperty: "WaveForecastingMenuNo"
      },
      {
        path: "/NetworkAnalysis/Dashboard",
        displayNameKey: "Network Metrics",
        iconClass: "bi bi-diagram-3",
        roles: ["admin"],
        menuProperty: "NetworkMetricsMenuNo"
      },
      {
        path: "/MethodologyValidation/Dashboard",
        displayNameKey: "Methodology Validation",
        iconClass: "bi bi-check2-circle",
        roles: ["admin"],
        menuProperty: "MethodologyValidationMenuNo"
      },
      {
        path: "/PaperData/Dashboard",
        displayNameKey: "📄 Paper Data",
        iconClass: "bi bi-file-earmark-text",
        roles: ["admin"],
        menuProperty: "PaperDataMenuNo"
      },
      {
        path: "/PaperVisualizations/Dashboard",
        displayNameKey: "📊 Paper Visualizations (All Figures)",
        iconClass: "bi bi-bar-chart-fill",
        roles: ["admin"],
        menuProperty: "PaperVisualizationsMenuNo"
      },
      {
        path: "/ViabilityPrediction/Dashboard",
        displayNameKey: "🔬 Company Viability Prediction (PhD)",
        iconClass: "bi bi-graph-up-arrow",
        roles: ["admin"],
        menuProperty: "ViabilityPredictionMenuNo"
      }
    ]
  }
];

export const getNavigationByRole = (userRole) => {
  return navigationConfig.map(category => ({
    ...category,
    items: category.items.filter(item => item.roles.includes(userRole))
  })).filter(category => category.items.length > 0);
};

export const getNavigationByCategory = (categoryName) => {
  return navigationConfig.find(category => category.category === categoryName);
};

export const getAllNavigationItems = () => {
  return navigationConfig.flatMap(category => category.items);
}; 